import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { userLogin } from "../api/userApi";
import { useUser } from "../context/userContext";

export default function LoginForm() {
    const navigate = useNavigate();

    const { setUser } = useUser();

    const [username, setUsername] = useState("")
    const [password, setPassword] = useState("");

    const login = async () => {
        try {
            const loginResponse = await userLogin(username, password);

            if (loginResponse.status === 200) {
                localStorage.setItem("UserId", loginResponse.data.userId);
                localStorage.setItem("Username", loginResponse.data.username);
                localStorage.setItem("Roles", JSON.stringify(loginResponse.data.roles));
                localStorage.setItem("Group", loginResponse.data.group);
                localStorage.setItem("Token", loginResponse.data.token);
                localStorage.setItem("RefreshToken", loginResponse.data.refreshToken);

                setUser({
                    userId: loginResponse.data.userId,
                    username: loginResponse.data.username,
                    roles: loginResponse.data.roles,
                });

                if (loginResponse.data.roles.includes("Admin") || loginResponse.data.roles.includes("Super Admin")) {
                    navigate("/admin/sales");
                }
                else if (loginResponse.data.roles.includes("Accountant")) {
                    navigate("/accounting/salesCommissions");
                }
                else {
                    navigate("/dashboard");
                }
            }
            else {
                alert("Login failed. Please check your credentials.");
            }
        }
        catch (error) {
            console.error("Login error:", error);
            alert("Login failed. Please try again.");
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        login();
    }

    return (
        <div className="login-form-container">
            <form className="login-form" onSubmit={handleSubmit}>
                <div className="login-form-content">
                    <h3 className="login-form-title">nexwave</h3>
                    <div className="form-group mt-3">
                        <label>Username</label>
                        <input
                            type="username"
                            className="form-control mt-1"
                            placeholder="Enter username"
                            onChange={(e) => setUsername(e.target.value)}
                        />
                    </div>
                    <div className="form-group mt-3">
                        <label>Password</label>
                        <input
                            type="password"
                            className="form-control mt-1"
                            placeholder="Enter password"
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>
                    <div className="d-grid gap-2 mt-3">
                        <button type="submit" className="btn btn-primary">
                            Login
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
}